<template>
  <div class="dashboard-chart-bar">
    <h2>{{ charttitle }}</h2>
    <div class="dashboard-chart-bar-container">
      <div class="dashboard-chart-bar-component" :id="chartid"></div>
      <div class="nodatachartinfo" v-if="show">{{ $t("DashboardProduct.nodata") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BarChart',
  props: {
    show: Boolean,
    chartid: String,
    charttitle: String,
    chartdata: {
      type: Object
    }
  },
  created() {
    this.$nextTick(() => {
      this.initBarChart(this.chartdata)
    });
  },
  computed: {
    // listenlan() {
    //   return this.$store.state.lan;
    // }
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.initBarChart(this.chartdata)
      });
    },
    // listenlan: function(){
    //   this.initBarChart(this.chartdata)
    // },
  },
  methods: {
    initBarChart: function(chartdata){
      let myBarChart = this.$echarts.init(document.getElementById(this.chartid))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: 0,
          data: chartdata.legenddata
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 5,
          top: 30,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 0,//全部显示
            rotate: chartdata.axisLabelrotate
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: chartdata.channelname
          //data: ['JD', 'TB', 'TM']
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: [
          {
            //name: '低价',
            name: chartdata.legenddata0,
            type: 'bar',
            stack: '总量',
            label: {
              show: true,
              position: 'insideRight'
            },
            data: chartdata.data0
            //data: [320, 302, 301]
          },
          {
            //name: '正常',
            name: chartdata.legenddata1,
            type: 'bar',
            stack: '总量',
            label: {
              show: true,
              position: 'insideRight'
            },
            data: chartdata.data1
            //data: [320, 302, 301]
          }
        ],
        color: chartdata.color ? chartdata.color : ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
        myBarChart.resize()
      }); 
    }
  }
}
</script>
